import { toJS } from 'mobx';
import React from 'react';
import Moment from 'moment-timezone';
import { debounce } from 'lodash';
import Helmet from 'react-helmet';
import queryString from 'query-string';

import progressionStore from 'modules/report/stores/progression';
import appStore from 'stores/app';

import Header from './components/Header';
import Filter from './components/Filter';
import ProgressionResults from './components/ProgressionResults';
import ReportCsv from './components/ReportCsv';
import { formatters } from '@Components/hierarchical-report/Layout';
import Configure from '@Components/hierarchical-report/configure';
import { useProgressionReportStore, ProgressionReportProvider } from './store'
import { ReportBody } from '@/components/reports/body';

class ProgressionLayout extends React.Component {
  state = {
    filterOpen: false,
    searchTerm: 'teste',
    isExport: false,
    params: {
      startDate: Moment.tz(appStore.timezone).startOf("day"),
      endDate: Moment.tz(appStore.timezone).endOf("day"),
      filterby: {}
    }
  }

  configure = {
    filterby: {
      options: [{
        value: 'publisher',
        get label() {
          return <formatters.Loadable isLoading={progressionStore.publisher.isLoading}>Publisher</formatters.Loadable>
        },
        options: progressionStore.publisher.fetchData,
      }, {
        value: 'allocation',
        get label() {
          return <formatters.Loadable isLoading={progressionStore.allocation.isLoading}>Allocation</formatters.Loadable>
        },
        options: progressionStore.allocation.fetchData,
      }, {
        value: 'path',
        get label() {
          return <formatters.Loadable isLoading={progressionStore.path.isLoading}>Path</formatters.Loadable>
        },
        options: progressionStore.path.fetchData,
      }, {
        value: 'pathUserProfile',
        get label() {
          return <formatters.Loadable isLoading={progressionStore.pathUserProfile.isLoading}>Path User Profile</formatters.Loadable>
        },
        options: progressionStore.pathUserProfile.fetchData,
      }],
    },
  }

  loadData = async () => {
    progressionStore.fetchData(this.state.params).then(() => this.setState({}));
    this.setState({});
  }

  componentDidMount () {
    const query = queryString.parse(this.props.location.search);
    let params = this.state.params;
    if (query.siteId) {
      params.siteId = query.siteId;
    } else {
      params.siteId = appStore.currentSiteID;
    }

    if (query.startDate) {
      params.startDate = Moment(query.startDate);
    }

    if (query.endDate) {
      params.endDate = Moment(query.endDate);
    }

    this.setState({params}, this.loadData);
  }

  handleClickFilter = () => {
    this.setState({ filterOpen: !this.state.filterOpen });
  }

  handleClickExport = () => {
    this.setState({ isExport: true });
    setTimeout(() => this.setState({ isExport: false }), 1000)
  }

  handleChangeSearch = (value) => {
    progressionStore.search(value);
  }

  handleChangeDates = ({ startDate, endDate }) => {
    this.setState(prevState => ({ params: { ...prevState.params, startDate, endDate } }), () => {
      if (startDate && endDate) {
        this.loadData();
      }
    });
  }

  handleChangeConfigure = state => {
    if (state.filterby) {
      state.filterby = Object.keys(state.filterby).reduce((filterby, field) => {
        const items = state.filterby[field].items.map(item => item.getValue())
        if (items.length > 0) filterby = { ...filterby, ...{ [field]: items } }
        return filterby
      }, {})
    }
    this.setState(prevState => ({ params: { ...prevState.params, filterby: state.filterby || {} } }), this.loadData)
    return state
  }

  handleChangeSelectConfigure = state => {
    this.setState(prevState => ({ params: { ...prevState.params, filterby: state.filterby || {} } }), this.loadData)
  }

  Configure = () => {
    const store = useProgressionReportStore()
    const { report: { useLoad }, reportView } = store
    useLoad()

    const { filterby } = this.state.params
    if (this.configure) {
      return <Configure key='filter' store={reportView} configure={this.configure} onApply={this.handleChangeConfigure} onSelect={this.handleChangeSelectConfigure} value={{ filterby }} />
    }
    return null
  }

  handleFilterClose = () => {
    this.setState({filterOpen: false});
  }

  handleFilterApply = (params) => {
    this.setState({
      params,
      filterOpen: false
    }, this.loadData);
  }

  render () {
    const { isLoading } = progressionStore.collection
    const searchData = toJS(progressionStore.collection.data);

    const data = searchData ? searchData.children : [];
    return (
      <ProgressionReportProvider>
        <Helmet title="Progression" />
        <Header
          onClickFilter={this.handleClickFilter}
          onChangeDates={this.handleChangeDates}
          onClickExport={this.handleClickExport}
          onChangeSelectProgressionType={this.handleChangeSlotCompletions}
          progressionType={this.state.progressionType}
          dates={{startDate: this.state.params.startDate, endDate: this.state.params.endDate}}
          sync={this.loadData}
          isLoading={isLoading}
        >
          <this.Configure />
        </Header>
        {this.renderFilter()}
        {this.state.isExport && <ReportCsv data={data} />}
        <ReportBody contentClassName='p-4'>
          <ProgressionResults data={data} />
        </ReportBody>
      </ProgressionReportProvider>
    );
  }

  renderFilter() {
    if (!this.state.filterOpen) {
      return null;
    }

    const dataSearch = searchTerm => {
      this.setState({searchTerm});
      debounce((term) => this.handleChangeSearch(term), 500)(searchTerm);
    };

    return (
      <Filter
        isOpen={this.state.filterOpen}
        onApply={this.handleFilterApply}
        onClose={this.handleFilterClose}
        onChangeSearch={dataSearch}
        search={this.state.searchTerm}
        params={this.state.params}
      />
    );
  }
}

export default ProgressionLayout;
